<template>
  <div class="paramNew" v-loading="isLoading" element-loading-spinner="el-icon-loading" @click.stop="closeSetting">
    <div class="paramNew-title">
      <!-- 测试key值 -->
      <!-- <span>fieldList：{{fieldList}}</span> -->
      <!-- <span>fieldDataList：{{fieldDataList}}</span> -->

      <span class="dataview">
        <span>{{ $t("device.dataview") }}</span>
        <div v-if="deviceInfo.status == 1" class="dataviewTitle">
          <img src="../assets/img/general/Subtract.png" alt="">
          <div class="dataspanTop"></div>
          <div class="dataspanBom">
            <p>{{ $t('device.dataTips') }}</p>
          </div>
        </div>
      </span>
      <!-- <span class="text">{{type==='protocol'?$t('device.parameter'):''}}</span> -->
      <el-popover v-model="settingVisible" class="param-set" popper-class="paramNew-choose" @click.stop>
        <div class="topLine">
          <!-- 显示参数 -->
          <div class="title">{{ $t('device.showParam') }}</div>
          <div class="titleRight" @click="resetField">{{ $t('device.refresh') }}</div>
        </div>
        <div class="topLine1">{{ $t('device.selecParameters') }}{{ showChoseNumber }}</div>
        <div class="choseContent" style="max-height:260px;overflow-y: scroll;">
          <div class="unitCheck" v-for="field in fieldList" :key="field.optional">
            <el-checkbox v-model="field.visable" @change="setFields(field)">{{ field.name }}</el-checkbox>
          </div>
        </div>
        <i slot="reference" class="iconfont icon-set" @click.stop></i>
      </el-popover>
    </div>
    <!-- 采集加速按钮 -->
    <!-- <el-button type="button" :class="{ 'collectFastButtonElse': (deviceStatus!=1&&deviceParamUpdata.length>0)}" class="collectFastButton" :disabled="collectFastButton"
       v-if="rechargeFlagObj&&rechargeFlagObj.energyFlowEnabled"  @click="goCollectionUp()">
      <el-tooltip :content="(deviceStatus!=1&&deviceParamUpdata.length>0)?$t('collectionFrequencyUP.collect_fasting'):$t('collectionFrequencyUP.collect_fast')" placement="top">
        <span class="collectFastButton-text">
        {{ (deviceStatus!=1&&deviceParamUpdata.length>0)?$t('collectionFrequencyUP.collect_fasting'):$t('collectionFrequencyUP.collect_fast') }}
        </span>
      </el-tooltip>
     <i  class="iconfont icon-caiji"></i>
    </el-button> -->
    <el-button type="button" :class="{ 'collectFastButtonElse': mqttStatusBoolean}" class="collectFastButton" :disabled="collectFastButton"
       v-if="rechargeFlagObj&&rechargeFlagObj.energyFlowEnabled"  @click="goCollectionUp()">
      <el-tooltip :content="mqttStatusBoolean?$t('collectionFrequencyUP.collect_fasting'):$t('collectionFrequencyUP.collect_fast')" placement="top">
        <span class="collectFastButton-text">
        {{ mqttStatusBoolean?$t('collectionFrequencyUP.collect_fasting'):$t('collectionFrequencyUP.collect_fast') }}
        </span>
      </el-tooltip>
     <i  class="iconfont icon-caiji"></i>
    </el-button>
    <!-- <div class="paramNew-list" :class="{ 'protocol': type === 'protocol', 'device': type === 'device' }"> -->
      <!-- 拖拽排序功能，使用vuedraggable -->
      <draggable v-model="fieldDataList" class="paramNew-list" :class="{ 'protocol': type === 'protocol', 'device': type === 'device' }" :options="{animation: 200}" @end="onDragEnd">
        <div v-for="(field, index) in fieldDataList" :key="field.par ? field.par : index" class="param-data"
          :class="{ 'protocol': type === 'protocol', 'device': type === 'device' }">
          <div class="num">{{ field.val }}{{ field.unit }}</div>
          <div class="name">{{ field.name }}</div>
        </div>
      </draggable>
    <!-- </div> -->
  </div>
</template>
<script>
import { i18n } from '@/i18n';
import draggable from 'vuedraggable';
import {  mapState } from "vuex";
export default {
  components: {
    draggable
  },
  props: {
    deviceInfo: {
      type: Object
    },
    deviceParamUpdata: {
      type: Array,
      default() {
        return []
      }
    },
    boardDataJudge: {
      type: Boolean,
      default: false
    },
    // websockDevideStatus: {
    //   default: 0
    // },
    // 是否走websock逻辑判断标识
    collEnergyFlaga: {
      type: Boolean,
      default: false
    },
    // MQTT是否成功推送数据
    mqttDataReceived: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    deviceInfo: {
      handler () {
        this.queryData()
        // this.collectionData()//判断能流采集频率升级是否显示
        this.collectFastButtonVisible()//判断能流采集频率升级是否显示
      },
      deep: true
    },
    // 能流采集频率数据更新
    deviceParamUpdata: {
      handler (newValue, oldValue) {
        if(newValue.length){
          console.log(this.fieldDataList,newValue,"2222222222222222222222222222222222222")
          this.updateValues(this.fieldDataList, newValue)
        }
      },
      deep: true
    },
    // // 设备状态
    // websockDevideStatus: {
    //   handler (newValue, oldValue) {
    //     this.deviceStatus = newValue
    //   },
    //   deep: true
    // },
    // 是否走websock逻辑判断标识
    collEnergyFlaga: {
      handler (newValue, oldValue) {
        console.log(newValue,"newValuenewValuenewValue")
        if(newValue){
          clearInterval(this.timerEnergyFiled);
          console.log("true清除轮询")
        }else{
          this.cycleQueryData()
          console.log("false开始轮询")
        }
      },
      deep: true
    }
  },
  data () {
    return {
      // 采集充值按钮显隐判断标志
      rechargeFlagObj: null,
      // deviceStatus:0,
      collectFastButton:false,
      // collectionUpDisplayVal:false,
      showChoseNumber: '(0/7)',
      timerEnergyFiled: "",
      fieldList: [], // 可选参数列表
      fieldDataList: [], // 显示的参数数据
      settingVisible: false, // 参数选择框是否可见
      isLoading: false, // 正在加载数据
    }
  },
  computed: {
    // mqtt链接状态且数据推送成功
    mqttStatusBoolean () {
      return this.$store.state.device.mqttStatus && this.mqttDataReceived
    },
    // 协议参数或设备参数
    type () {
      // 不知道此处的'protocol'样式什么情况会出现，暂时保留，页面设备出现了无SN实施参数变形状况，改成PN判断
      // return this.deviceInfo.sn ? 'device' : 'protocol'
      return this.deviceInfo.pn ? 'device' : 'protocol'
    },
    chosenFields () {
      return this.fieldList.filter(item => !!item.visable)
    },
    optionalFields () {
      return this.fieldList.filter(item => !item.visable)
    },
     ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
    
  },
  mounted () {
    this.queryData();
    this.cycleQueryData()
    console.log("mountedmounted开启轮询")
    // this.collectionData()//判断采集升级按钮显影
    this.collectFastButtonVisible()//判断采集升级按钮显影
  },
  beforeDestroy () {
    clearInterval(this.timerEnergyFiled);
  },
  methods: {
    // 拖拽结束时的回调，可在此处进行排序结果的保存或后端同步
    onDragEnd(evt) {
      // console.log('拖拽结束:', evt);
      // 拖拽排序后，更新每个item的sortnum为index+1
      this.fieldDataList.forEach((item, idx) => {
        item.sortnum = idx + 1;
      });
      // 同步到后端
      let param = {
        uid: this.$store.state.user.uidExtra,
        devcode: this.deviceInfo.devcode,
        parameter: this.fieldDataList.map(item => ({ par: item.par, sortnum: item.sortnum })),
        i18n: this.$lang.currentLang
      };
      this.isLoading = true;
    let url = this.isMicroService ? "/ppe/api/auth/web/updateDeviceParsSort" : "updateDeviceParsSort";
    let method = this.isMicroService ? "postDeviceParsSort" : "post";
        // info.Loading = true;
        this.$request[method](url, param).then(res => {
      // this.$request.postDeviceParsSort('updateDeviceParsSort', param).then(res => {
        if (res[this.code] === 0) {
          // 成功处理
          setTimeout(() => {
            this.queryFieldData()
          }, 100);
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    updateValues(A, B) {
      const lookup = new Map();
      A.forEach(item => lookup.set(item.par, item));

      // 遍历B中的每一项
      B.forEach(bItem => {
          // 在查找表中找到具有相同par的项并更新其val属性
          // const aItem = lookup.get(bItem.optional);
          const aItem = lookup.get(bItem.par);
          if (aItem) {
            // console.log(aItem,'aItemaItemaItemaItemaItemaItem')
            // console.log(bItem,'bItembItembItembItem')
              if(bItem.val == '-' || bItem.val == '--'){
                bItem.val = 0;
              }
              let num = Number(bItem.val); 
              if (Number.isNaN(num)) {
                aItem.val = bItem.val;
              } else {
                aItem.val = parseFloat(this.$filter.formatNum(bItem.val, 2));
              }
              // aItem.val = parseFloat(bItem.val);
              // aItem.val =element.val = parseFloat(this.$filter.formatNum(bItem.val, 2));
          }
      });
    },
    // // 判断采集升级按钮显影
    // collectionData(){
    //   this.$request
    //     .get("queryRechargeEnergyFlag", {
    //       devcode: this.deviceInfo.devcode,
    //       i18n: this.$lang.currentLang
    //     })
    //     .then(res => {
    //       if (res.err == 0) {
    //         this.collectionUpDisplayVal = true
    //       }else {
    //         this.collectionUpDisplayVal = false
    //       }
    //     }).catch(e => {
    //       this.collectionUpDisplayVal = false
    //   });
    // },
    // 判断采集充值按钮显隐
    collectFastButtonVisible() {
      this.$request.getDEVMicroservices("/ros/api/recharge/tariff/queryDisRechargeFlag", {pn: this.deviceInfo.pn}).then(res => {
        if (res.code === 0) {
          this.rechargeFlagObj =  res.data
          // this.rechargeFlagObj =  {accelerateEnabled: true, energyFlowEnabled: true}
        }
      });
    },
      // 采集频率升级页面
      goCollectionUp(){
      //   this.collectFastButton = true;
      //   this.$request
      //   .get("judgeCollRecharge", {
      //     type: 1,
      //     pn: this.deviceInfo.pn,
      //     i18n: this.$lang.currentLang
      //   })
      //   .then(res => {
      //     if (res.err == 0) {
      //       this.$store.commit('saveIsShow', 9);
      //       this.$store.state.event.foldGeneralSidebarNew = true;
      //       this.$emit('statisticnewCollectionUPType', 1);
      //     }else if(res.err == 8){
      //       this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
      //     }else if(res.err == 9){
      //       this.$message.error(this.$t('collectionFrequencyUP.noRecharg_min'));
      //     }else if(res.err == 4099){
      //       this.$message.error(this.$t('collectionFrequencyUP.noRecharg_wifi'));
      //     }else {
      //       this.$message.error(this.$t(`errCode.${res.err}`));
      //     }
      //     this.collectFastButton = false
      //   }).catch(e => {
      //     this.collectFastButton = false
      // });
          this.collectFastButton = true;
          this.$request.getMicroserDess(`/css/api/auth/web/collectorForDIS/${this.deviceInfo.pn}`).then(res => {
            this.collectFastButton = false;
            if (res.code === 0) {
              if (!res.data.transmissionMode) {
                this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
                return;
              }
              let mode = res.data.transmissionMode.toLowerCase();
              let gprsType = '4G';
              if (mode.includes('wi') || mode.includes('wf')) {
                gprsType = 'WIFI';
              } else if (mode.includes('gprs')) {
                // gprsType = '2G';
                this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
                return;
              }else{
                // gprsType = '4G';
                this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
                return;
              }
              this.gprsType = gprsType;
              // TODO: 根据 gprsType 执行后续逻辑
              this.$store.commit('saveIsShow', 9);
              this.$store.state.event.foldGeneralSidebarNew = true;
              this.$emit('collectionUPEvent', {
                collectionUPType: 1,
                gprsType: gprsType,
                rechargeFlagObj: this.rechargeFlagObj
              });
            }else{
              this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
            }
          }).catch(() => {
            this.collectFastButton = false;
          });
      },
    // 查询页面数据
    queryData () {
      this.isLoading = true;
      this.queryFields().then(result => {
        result && this.queryFieldData()
      }).catch(() => {
        this.isLoading = false;
      })
    },
    cycleQueryData () {
      this.timerEnergyFiled = setInterval(() => {
        this.queryData()
      }, 60000)
    },
    // 查询参数列表
    queryFields () {
      this.isLoading = true;
      let param = {
        devcode: this.deviceInfo.devcode,
        i18n: this.$lang.currentLang,
        uid: this.$store.state.user.uidExtra
      }
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceChartsFields" : "queryDeviceChartsFieldsEs";
      return this.$request[this.method](url,  param).then(res => {
        this.isLoading = false;
        if (res[this.code] === 0) {
          this.fieldList = res[this.resData]
          // 日月元排序需求
          try {
            this.fieldList = this.fieldList.sort((a, b) => {
              return String(a.name || '').localeCompare(String(b.name || ''))
            })
          } catch (e) {
            console.error('fieldList 排序失败，使用原始顺序:', e)
            this.fieldList = res[this.resData]
          }
          let choseNumber = this.fieldList.filter(item => !!item.visable)
          this.showChoseNumber = "(" + choseNumber.length + "/7)"
          return true
        } else {
          this.fieldList = []
          return false
        }
      }).catch(err => {
        this.isLoading = false;
        this.fieldList = [];
        console.error('queryDeviceChartsFieldsEs 接口调用失败:', err);
        return false;
      })
    },
    // 查询参数数据
    queryFieldData () {
      let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        i18n: this.$lang.currentLang,
        uid: this.$store.state.user.uidExtra
      }
      this.isLoading = true
         this.isLoading = true;
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDevicePars" : "queryDeviceParsEs";
      this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
         let arr = this.isMicroService ?  res[this.resData]:res[this.resData].parameter ;
          arr.forEach(element => {
            if(element.val == '-' || element.val == '--'){
              element.val = 0;
            }
            element.val = parseFloat(this.$filter.formatNum(element.val, 2))
          });
          this.fieldDataList = arr
          this.$emit('update:boardDataJudge', true);
        }
        this.isLoading = false
      }).catch(e => {
        this.isLoading = false
      })
    },
    //勾选时触发的事件
    setFields (field) {
      // 记录当前操作前的状态
      const oldValue = field.visable;
      if (this.chosenFields.length < 1) {
        this.$message.warning(i18n.t('device.minSelect'));
        this.$nextTick(() => {
          field.visable = !oldValue;
        });
        return;
      }
      if (this.chosenFields.length > 7) {
        this.$message.warning(i18n.t('device.maxSelect'));
        this.$nextTick(() => {
          field.visable = !oldValue;
        });
        return;
      }
      let param = {
        devcode: this.deviceInfo.devcode,
        optional: field.optional,
        visable: field.visable,
        uid: this.$store.state.user.uidExtra
      };
    let url = this.isMicroService ? "/ppe/api/auth/web/editDeviceChartsVisable" : "editDeviceChartsVisable";
        // info.Loading = true;
        this.$request[this.method](url,param).then(res => {
        if(res[this.code] === 0) {
          this.queryFieldData();
          this.queryFields();
        } else {
          this.$message.error(this.$t(`errCode.${res[this.code]}`));
        }
      });
    },
    // 重置参数可见性
    resetField () {
      let param = {
        devcode: this.deviceInfo.devcode,
        i18n: this.$lang.currentLang,
        uid: this.$store.state.user.uidExtra
      }
      let url = this.isMicroService ? "/ppe/api/auth/web/editDeviceChartsReset" : "editDeviceChartsReset";
        // info.Loading = true;
        this.$request[this.method](url, param).then(res => {
        if (res[this.code] === 0) {
          this.queryData()
        }else{
          this.$message.error(this.$t(`errCode.${res[this.code]}`))
        }
      })
    },
    // 关闭设置窗口
    closeSetting () {
      this.settingVisible = false
    }
  },
}
</script>
<style lang="less">
@import url('../assets/css/mixin.less');
.paramNew-title{
  min-width: 200px;
}

.paramNew-choose {
  width: 200px;
  background: rgba(34, 45, 53, 1);
  border: none;
  padding: 8px 2px;
  margin-right: 20px;

  .title {
    .sc(14px, #fff);
    font-weight: bold;
  }

  .titleRight {
    cursor: pointer;
    color: @primaryTextColor;
  }

  .topLine {
    display: flex;
    justify-content: space-between;
    align-content: center;
    color: rgba(235, 235, 235, 1);
    padding: 12px 16px;
  }

  .topLine1 {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    color: rgba(235, 235, 235, 1);
    padding: 0 16px;
  }

  .choseContent {
    // min-height: 200px;
    min-height: 40px;
    display: flex;
    flex-direction: column;

    .unitCheck {
      width: 100%;
      padding: 10px 0px 10px 16px;

      &:hover {
        background-color: @primaryColorTransparency30;
      }
    }
  }

  .popper__arrow {
    display: none;
  }

  .el-checkbox .el-checkbox__input .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }

  .el-checkbox .el-checkbox__input .el-checkbox__inner:hover,
  .el-checkbox .el-checkbox__input .el-checkbox__inner:focus {
    border: 1px solid rgba(235, 235, 235, 1);
    background: transparent;
  }

  .el-checkbox .el-checkbox__label {
    font-size: 14px;
    color: rgba(235, 235, 235, 1);
  }

  .el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: rgba(235, 235, 235, 1);
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    // background: @primaryTextColor;
    // border-color: @primaryTextColor;
    background: transparent;
    border-color: rgba(235, 235, 235, 1);
  }

  .el-checkbox .el-checkbox__input .el-checkbox__inner::after {
    top: 2px;
    left: 5px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    background-color: #222d35;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(180, 184, 193, 1);
    border-radius: 3px;
  }

  .el-checkbox.is-checked .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: @primaryTextColor;
  }
}
</style>
<style lang="less" scoped>
@import url('../assets/css/mixin.less');

.paramNew {
  // padding: 10px 20px 25px;
  margin-top: 15px;
  padding: 12px;
  display: flex;
  flex-direction: column;

  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding:10px 0 0 0;
    padding: 0px;

    .text {
      .sc(14px, #333);
      font-weight: bold;
    }

    .param-set {
      i {
        .sc(20px, #ccc);
        cursor: pointer;

        &:hover {
          // color: @themeColor;
          color: @primaryTextColor;
        }
      }
    }

    .dataview {
      display: flex;
      position: relative;
      font-size: 16px;

      .dataviewTitle {
        img {
          margin-left: 4px;
          margin-top: 4px;
          width: 16px;
          height: 16px;
        }

        &:hover .dataspanBom {
          display: block;
        }

        &:hover .dataspanTop {
          display: block;
        }

        .dataspanBom {
          border-radius: 8px;
          background-color: #D9E2E6;
          color: #2B3842;
          padding: 8px;
          font-size: 12px;
          position: absolute;
          width: 156px;
          left: 0;
          top: 30px;
          // opacity: 0.7;
          display: none;
        }

        .dataspanTop {
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-bottom-color: #D9E2E6;
          top: 14px;
          left: 68px;
          position: absolute;
          display: none;
        }
      }
    }
  }

  &-list {
    flex: 1;
    display: grid;
    // align-content: center;
    grid-column-gap: 20px;
    padding-bottom: 5px;
    overflow: scroll;

    &.protocol {
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
    }

    &.device {
      grid-auto-flow: row;
      grid-auto-rows: 1fr;
    }

    .param-data {
      // padding:10px 45px;
      display: grid;
      flex-direction: column;
      margin-top: 12px;
      text-align: center;

      // background: #E7F1FC;
      &.protocol {
        border-radius: 5px;
        padding: 10px 25px;
        background: #5495FD;

        .num {
          // align-self: flex-start;
          align-self: flex-end;
          .sc(28px, #fff);
        }

        .name {
          // align-self: center;
          align-self: flex-start;
          .sc(14px, #fff);
          margin-top: 10px;
        }
      }

      &.device {
        border-radius: 5px;
        padding: 10px 45px;
        // background: #E7F1FC;
        background: @primaryButtonColor;

        .num {
          min-width: 120px;
          // align-self: flex-start;
          align-self: flex-end;
          .sc(28px, #ffffff);
        }

        .name {
          min-width: 120px;
          // align-self: center;
          align-self: flex-start;
          // .sc(14px, @themeColor);
          .sc(14px, #ffffff);
          // margin-top: 10px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space:nowrap;
        }
        .name:hover {
          min-width: 120px;
          align-self: flex-start;
          .sc(14px, #ffffff);
          overflow: visible;
          white-space:normal;
        }
      }

    }
  }
  .collectFastButton{
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    width:fit-content;
    background: #22413b;
    padding: 2px 5px;
    border: 1px solid #30EC70;
    color: #30EC70;
    border-radius: 6px;
    line-height: 1.2;
}
.collectFastButton-text {
  display: inline-block;
  max-width: 174px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1.5;
  height: 24px; 
  vertical-align: middle;
}
.collectFastButton .iconfont {
  font-size: 18px; 
  // margin-left: 6px;
  vertical-align: middle;
  line-height: 1;
}
.collectFastButtonElse{
    background-size: cover !important; /* 图片大小填充整个容器 */
    background-position: center !important; /* 背景图居中 */
    background-repeat: no-repeat !important;
    background: url("../assets/img/accelerating.gif");
}

  // 加载数据时遮罩
  /deep/.el-loading-mask {
    // background-color: rgb(34, 45, 53, .5);
    background-color: transparent;
  }

  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
  }

  /deep/.el-loading-spinner .path {
    stroke: @primaryTextColor !important;
  }
}
</style>
